module.exports = __webpack_public_path__ + "img/malla mosquitera.98440504.jpg";